<template>
  <div class="bg-white p-4">
    <div class="row mb-4">
      <div class="col-12 header">
        <div style="display: flex">
          <span class="header-icon">
            <i class="fas fa-columns"></i>
          </span>
          <h2>
            {{ $t('menu.settings.accountData.custom') }}
          </h2>
        </div>
      </div>
      <div class="col-12">
        <p>
          {{ $t('menu.settings.accountData.descriptionCustom') }}
        </p>
      </div>
    </div>

    <div>
      <div class="row">
        <div class="col-12">
          <div class="main-container">
            <div class="wrapper" style="min-width: 75%; margin-right: 16px">
              <div class="row">
                <div class="col-8">
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <label class="idx-bold" for="email-subject">
                          {{ $t('menu.settings.accountData.subject') }}
                        </label>

                        <input
                          type="text"
                          id="email-subject"
                          class="form-control"
                          placeholder="Informe o assunto do email"
                          v-model="email.subject"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label class="idx-bold" for="email-sender">
                          {{ $t('menu.settings.accountData.sender') }}
                        </label>

                        <input
                          type="text"
                          id="email-sender"
                          class="form-control"
                          placeholder="Informa o nome do rementente"
                          v-model="email.sender"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <wysiwyg
                        api-key="no-api-key"
                        license_key="gpl2"
                        tinymceScriptSrc="https://tinymce5.s3.amazonaws.com/tinymce/tinymce.min.js"
                        v-model="email.html"
                        :init="{
                          menubar: false,
                          statusbar: false,
                          height: 400,
                          language: $t('newAction.stepOne.editorLanguage'),
                          plugins: 'link image lists hr emoticons',
                          toolbar:
                            'bold italic underline | alignleft aligncenter alignright alignjustify | link image | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight | code',
                          lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
                          font_formats:
                            'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                          image_description: false,
                          image_title: false,
                          content_style:
                            'img {max-width: 100%; max-height: 100%}',
                          image_dimensions: false,
                          file_picker_types: 'image',
                          images_upload_handler: imagesUploadHandlerBody,
                        }"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-4">
                  <div class="template">
                    <h5>
                      {{ $t('menu.settings.accountData.templates') }}
                    </h5>
                    <p>
                      {{ $t('menu.settings.accountData.descriptionTemplate') }}
                    </p>

                    <br />

                    <h5>
                      {{ $t('menu.settings.accountData.myTemplates') }}
                    </h5>
                    <p>
                      {{
                        $t('menu.settings.accountData.descriptionMyTemplates')
                      }}
                    </p>

                    <b-form-select
                      @change="handleTemplateSelected"
                      v-model="templateSelected"
                      :options="templateOptionsLean"
                    ></b-form-select>

                    <br />
                    <br />

                    <h5>
                      {{ $t('menu.settings.accountData.saveTemplates') }}
                    </h5>
                    <div class="search-answers">
                      <input
                        type="text"
                        class="form-control"
                        id="input-template-name"
                        placeholder="Digite o nome de um template"
                        v-model="newTemplateName"
                      />
                      <button
                        @click="saveTemplate"
                        class="btn btn-outline-primary mt-2"
                      >
                        {{ $t('menu.settings.accountData.save') }}
                      </button>
                      <button
                        @click="updateTemplate"
                        class="btn btn-outline-primary mt-2"
                      >
                        {{ $t('menu.settings.accountData.updateTemplate') }}
                      </button>
                      <button
                        @click="deleteTemplate"
                        class="btn btn-outline-danger mt-2"
                      >
                        {{ $t('menu.settings.accountData.deleteTemplate') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert';
import api from '../../../services/api';

export default {
  data: () => ({
    userAuth: {},
    email: {
      subject: 'Retorno Equipe Experiência do Cliente',
      sender: null,
      html: null,
    },
    templateOptions: [],
    templateSelected: null,
    templateNameSelected: null,
    newTemplateName: null,
  }),

  methods: {
    async updateTemplate() {
      await api.put(
        'template-treatment',
        {
          idTemplate: this.templateSelected,
          html: this.email.html,
          sender: this.email.sender,
          subject: this.email.subject,
        },
        { headers: { 'x-access-token': this.userAuth.token } },
      );

      this.getTemplates(true);

      swal({
        title: 'Template atualizado',
        text: 'Seu template foi alterado com sucesso!',
        icon: 'success',
        buttons: 'Ok',
      });
    },

    async deleteTemplate() {
      await api.put(
        'update-default-template',
        {
          idTemplate: this.templateSelected,
          html: this.email.html,
          sender: this.email.sender,
          subject: this.email.subject,
        },
        { headers: { 'x-access-token': this.userAuth.token } },
      );

      this.getTemplates(true);

      swal({
        title: 'Template Deletado',
        text: 'Seu template foi deletado com sucesso!',
        icon: 'success',
        buttons: 'Ok',
      });
    },

    async saveTemplate() {
      if (!this.email.subject || !this.email.sender || !this.newTemplateName) {
        swal({
          title: 'Atenção!',
          text: 'Preencha todos os campos!',
          icon: 'warning',
          buttons: 'Ok',
        });
      } else {
        await api.post(
          '/default-template',
          {
            name: this.newTemplateName,
            subject: this.email.subject,
            sender: this.email.sender,
            html: this.email.html,
          },
          {
            headers: { 'x-access-token': this.userAuth.token },
          },
        );

        this.email.subject = '';
        this.email.send = '';
        this.email.html = '';
        this.newTemplateName = '';

        this.templateOptions = [];

        this.getTemplates();

        swal({
          title: 'Template salvo',
          text: 'Seu template foi salvo com sucesso!',
          icon: 'success',
          buttons: 'Ok',
        });
      }
    },

    async getTemplates(updateSelect) {
      const response = await api.get('/get-default-template', {
        headers: { 'x-access-token': this.userAuth.token },
      });

      if (updateSelect) {
        this.templateOptions = [];
      }

      this.templateOptions.push({
        value: null,
        text: 'Selecione um template',
        subject: null,
        sender: null,
        html: null,
      });

      response.data.forEach((el) => {
        this.templateOptions.push({
          value: el._id,
          text: el.name,
          subject: el.subject,
          sender: el.sender,
          html: el.html,
        });
      });
    },

    handleTemplateSelected() {
      const template = this.templateOptions.find(
        (el) => el.value === this.templateSelected,
      );

      this.email.subject = template.subject;
      this.email.sender = template.sender;
      this.email.html = template.html;
      this.templateNameSelected = template.text;
    },

    async imagesUploadHandlerBody(blobInfo, success, failure) {
      if (!blobInfo) {
        return;
      }

      try {
        const formData = new FormData();

        formData.append('file', blobInfo.blob(), blobInfo.filename());

        const response = await api.post(
          '/close-the-loop/image-body',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'x-access-token': this.userAuth.token,
            },
          },
        );

        success(response.data);
      } catch (error) {
        failure(error);
      }
    },
  },

  watch: {
    templateNameSelected: function watchTemplateSelected(value) {
      if (value === 'Selecione um template') {
        this.email.html = '';
      }
    },
  },

  computed: {
    templateOptionsLean() {
      return this.templateOptions.map((el) => ({
        value: el.value,
        text: el.text,
      }));
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    await this.getTemplates();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';

.template {
  border: 1px solid #c1c1c1;
  border-radius: 5px;
  padding: 16px;
  height: 100%;
}

h2 {
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 100;
  color: $gray;
}

.header-icon {
  margin: 4px 8px 0 0;
  font-size: 12px;
  color: $gray;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/default-templates/index.vue